export default __webpack_public_path__ + "static/media/select-dropdown.b6cceddb.svg";